import React, { Component } from 'react';
import axios from "axios";
import HomePage from './HomePage';
import JNJSurvey from '../../assets/JNJSurvey.png';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import Modal from 'react-modal';
import cancelbtn from "../../assets/cancelbtn.png";

const re=/^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*;{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/;
class EndPage extends Component { 
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            result: null,
            isHomePage: false,
            surveyURL: 'https://forms.office.com/Pages/ResponsePage.aspx?id=M0vJOjWRIUiVAur9plkqNW02wbzGQNZOgPu0aVMhDgJUOTNITkozTEg3NVc2NFkwMzVXOVRRMEg1Sy4u',
            issurveyFeedback: '',
            isEmailmodalOpen : false,
            emailSentSuccess: false,
            emailSentError:false,
            managerName:'',
            leCode: '',
            leName: '',
            payrollMRCCode: '',
            payrollMRCName: '',
            payrollCCCode: '',
            payrollCCName: '',
            headcountCCCode:'',
            headcountCCName:'',
            headCountMRCCode:'',
            headCountMRCName:'',
            mngName:'',
            managerlocation:'',
            email:'',
            emails:[],
            emailError:'',
            popupheight: 0
        }
    }
    componentWillMount() {
        const { cookies } = this.props;
        var isFeedbackSurvey = cookies.get('isFeedback');
        if (isFeedbackSurvey != undefined) {
            this.setState({ issurveyFeedback: 'true' })
        }
        else {
            this.setState({ issurveyFeedback: 'false' })

        }
    }
    async  componentDidMount() {
        if (this.props.mngwwid != '' && this.props.locationreferenceID != '') {
            await axios({
                method: 'POST',
                url: process.env.REACT_APP_WORKDAY_API_URL + 'saveSummary',
                headers: {
                    'apiKey': process.env.REACT_APP_WORKDAY_API_KEY,
                    'clientKey': process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
                    'Content-Type': 'application/json'
                },
                data: {
                    "sessionId": this.props.sessionID,
                    "managerWWID": this.props.mngwwid,
                    "locationCode": this.props.locationreferenceID,
                    "leCode": this.props.lecode,
                    "leName": this.props.leName,
                    "payrollMRCCode": this.props.payrollmrccode,
                    "payrollMRCName": this.props.payrollMRCName,
                    "payrollCostCenterCode": this.props.payrollCCCode,
                    "payrollCostCenterName": this.props.payrollCCName,
                    "headCountMRCCode": this.props.headCountMRCCode,
                    "headCountMRCName": this.props.headCountMRCName,
                    "headCountCostCenterCode": this.props.headcountCCcode,
                    "headCountCostCenterName": this.props.headCountCCName,
                    "summaryTakenAtStage": this.props.summaryTakenAtStage,
                    "noneOfTheAboveSelected": this.props.noneOfTheAboveSelected
                }


            }).then((res) => {
                this.setState({
                    result: res.data.summarySaved,
                });
            }).catch((error) => {
                //on error
                //  alert("There is an error in API call mngid.");
            });
        }
        else {

        }

    }
    handleEndPageDataBack = () => {
        this.props.onclickEndPageBack();
    }
    handleEndPagenext = () => {
        this.setState({ isHomePage: true })
        this.props.onclickEndPageNext();

    }
    handleEmailbtn =() =>{
        this.setState({
            isEmailmodalOpen : true ,
            managerName : this.props.mngwwid,
            mngName: this.props.mngName,
            managerlocation : this.props.managerlocation,
            leCode: this.props.lecode,
            leName: this.props.leName   
        });
        if(this.props.summaryTakenAtStage == "payrollCostCenter"){
            this.setState({
                payrollMRCCode: this.props.payrollmrccode,
                payrollMRCName: this.props.payrollMRCName,
                payrollCCCode: this.props.payrollCCCode,
                payrollCCName: this.props.payrollCCName
            });
        } 
        else if(this.props.summaryTakenAtStage == "headcountCostCenter"){
            this.setState({
                payrollMRCCode: this.props.payrollmrccode,
                payrollMRCName: this.props.payrollMRCName,
                payrollCCCode: this.props.payrollCCCode,
                payrollCCName: this.props.payrollCCName,
                headCountMRCCode: this.props.headCountMRCCode,
                headCountMRCName: this.props.headCountMRCName,
                headcountCCCode: this.props.headcountCCcode,
                headcountCCName: this.props.headCountCCName
            });
        }   
        
        //this.props.onclickEmail();
    }
    handleEmailSuccess=()=>{
        document.getElementById("emailSubmitbtn").disabled = true;
            this.setState({
                emailSentError : false
            });
        if (this.state.emails.length > 0) {
            axios({
                method: 'POST',
                url: process.env.REACT_APP_WORKDAY_API_URL + 'sendEmail',
                headers: {
                    'apiKey': process.env.REACT_APP_WORKDAY_API_KEY,
                    'clientKey': process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
                    'Content-Type': 'application/json'
                },
                data: {
                    "to" : this.state.emails,
                    "emailBody" : this.refs.textarea.innerHTML,
                    "emailEditable" : this.refs.textarea1.innerHTML
                }
            }).then((res) => {
                this.setState({
                    emailSentSuccess:true,
                    isEmailmodalOpen :false,
                    emailSentError: false
                });
            }).catch((error) => {
                //on error
                console.log(error);
                //alert("Please verify the email address")
                this.setState({
                    emailSentError:true
                });
            });
        }
        else{
            //alert("Please verify the email address")
                this.setState({
                    emailSentError:true
                });
        }
    }
    handleEmailPopUp=() =>{
        this.setState({
            emailSentSuccess:false,
            emailError:'',
            emails:[]

        })
    }
    handleChange=(evt)=>{
        this.setState({
            email:evt.target.value,
            emailError: null
        });
    }
    handleKeyDown=(evt)=>{
        if (['Enter', 'Tab',' ', ',' , ';'].includes(evt.key)) {
            evt.preventDefault();
              
            var value = this.state.email.trim();
              
            if (value && this.validateEmail(value)) {
              this.setState({
                emails: [...this.state.emails, value],
                email: ''
              });
            }
          }
    }
    handleBlur =() =>{
        var value = this.state.email.trim();

        if(value && this.validateEmail(value)){
            this.setState({
                emails: [...this.state.emails, value],
                email:''
            });
        }
    }
    handleDelete=(toBeRemoved)=>{
        this.setState({
            emails: this.state.emails.filter(email => email !== toBeRemoved)
          });
    }
    handlePaste = (evt) => {
        evt.preventDefault();
        
        var paste = evt.clipboardData.getData('text');
        
        var emails = [];
        var emails= paste.split(/[\s,;]+/);
        if (emails) {
          //var toBeAdded = emails.filter(email => !this.isInList(email));
          var toBeAdded = emails.filter(email => this.validateEmail(email.trim()));
          this.setState({
            emails: [...this.state.emails, ...toBeAdded]
          });
        }
      }
    validateEmail(email){
        var err = null;
        var isValidEmail = re.test(email);
        if (!isValidEmail) {
            err=`${email} is not a valid email address`;
          }
         if(!email.includes('its.jnj.com') && !email.includes('jnj.com') && isValidEmail){
            err=`${email} is outside domain`;
         } 
        if (this.isInList(email)) {
                err=`${email} has already been added`;
        }
        if(err){
            this.setState({
                emailError: err
            });
            return false;
        }
        return true;
    }
    isInList(email) {
        return this.state.emails.includes(email);
      }
    close=()=>{
        this.setState({
            isEmailmodalOpen :false,
            emailError:'',
            email:'',
            emails:[]
        });
    } 
    refreshPage = () => {
        window.location.reload(false);
    }
    handleErrorEmailPopUp=()=>{
        document.getElementById("emailSubmitbtn").disabled = false;
        this.setState({
            emailSentError: false
        });
    }
    surveyPage = () => {

        let d = new Date();
        d.setTime(d.getTime() + (129600 * 60 * 1000));

        const { cookies } = this.props;
        cookies.set('isFeedback', 'true', { path: '/', expires: d });
    }
    render() {

        return (
            <div>{this.state.isHomePage === true ? '' :
                <div>
                    {this.props.outputmsg == "success" ?
                        <div className="Endpageheader">
                            <h4 className="successheader">SUCCESS!</h4>
                            <div className="Endtitleheader">
                                <p>Your selected LE/MRC/CC values are shown at right.</p>
                                <p>Please copy and paste these values into your job requistion in Workday or click on the email button to have the information sent to the emails you provide.</p>
                            </div>
                        </div> : this.props.outputmsg == "noa" ?
                            <div className="Endpageheadernoa">
                                <div className="Endtitleheadernoa">
                                    <p>Please contact your Manager or local finance department for the fields you selected "None of the above".</p>
                                </div>
                            </div>
                            : this.props.outputmsg == "nodata" ?
                                <div className="Endpageheadernodata">
                                    <div className="Endtitleheadernodata">
                                        <p>There is no organizational information for the location selected for this Hiring Manager,
                                       please contact your Manager or local finance department to help identify
          (Legal Entity, Payroll MRC, Payroll cost center, Headcount MRC and Headcount Cost Center)</p>
                                    </div>
                                </div> : ''
                    }
                    <div className='last-column rowhead lebtn'>

                        <div className="nextbtn leback"> <input type="submit" value="< Back"
                            className="btncls" onClick={this.handleEndPageDataBack} /></div>
                        <div className="nextbtn lenext"> <input type="submit" value="Start Over"
                            className="btncls" onClick={this.handleEndPagenext} /></div>
                        {this.props.outputmsg == "success" &&    
                        <div className="nextbtn lenext"> <input type="submit" value="Email"
                        className="btncls" onClick={this.handleEmailbtn} /></div> }   

                    </div>
                    <Modal
                        isOpen={this.state.isEmailmodalOpen}
                        className="Modal emailPopUpWrapper" 
                        ariaHideApp={false}
                        >
                        <div className="outer emailModalWrapper">
                            <div className="emailModalInnerWrapper">
                                <div className="emailAddress">
                                <span><img className="cancelButton" src={cancelbtn} onClick={this.close}/></span>
                                <span> <h4 className="emailIdheader">Send Email</h4></span>   
                                </div>
                                <div className="emailInput">
                                {this.state.emails.map(email => 
                                <div className="email-chip" key={email}>{email}
                                    <button
                                    type="button"
                                    className="button"
                                    onClick={() =>  this.handleDelete(email)}
                                    >
                                    &times;    
                                    </button>
                                </div>)}
                                <input type="text" className="emailIdContent" name="emailId" placeholder="Please enter email addresses" value={this.state.email} onChange={this.handleChange} onKeyDown={this.handleKeyDown} onPaste={this.handlePaste} onBlur={this.handleBlur}></input>
                                </div>
                                <div className="hrline"></div>
                                
                                {this.state.emailError &&
                                <p className="emailIdError">{this.state.emailError}</p>
                                }
                                <div className="emailInput">
                                <div contentEditable="true" ref="textarea1" className="emaileditableContent" name="emailcontent" placeholder="Add a message (optional)">
                                </div>
                                </div>
                                <div className="hrline"></div>
                                
                                <div className="emailContent">
                                    <div className="emailBodyOuterWrapper">
                                        <div contentEditable="false" ref="textarea" className="emailBody" suppressContentEditableWarning="true">
                                        <br/>
                                        <b>LE-MRC-CC Predictor Tool - Your Selected Values:</b><br /><br />
                                        <div className="selectedSummaryHeader"><b>Hiring Manager</b></div>
                                        {this.state.managerName} - {this.state.mngName}<br/><br/>
                                        <div className="selectedSummaryHeader"><b>Requisition Location</b></div>
                                        {this.state.managerlocation}<br/><br/>
                                        {this.state.leCode != ''?
                                            <div>
                                            <div className="selectedSummaryHeader"><b>Legal Entity</b></div>
                                            {this.state.leCode} - {this.state.leName}<br/><br/>
                                            </div>:''
                                        }
                                        {this.state.payrollMRCCode != ''?
                                        <div>
                                        <div className="selectedSummaryHeader"><b>Payroll MRC</b></div>
                                        {this.state.payrollMRCCode} - {this.state.payrollMRCName}<br/><br/>
                                        </div>: ''
                                        }
                                        {this.state.payrollCCCode != ''?
                                        <div>
                                        <div className="selectedSummaryHeader"><b>Payroll Cost Center</b></div>
                                        {this.state.payrollCCCode} - {this.state.payrollCCName}<br/><br/>
                                        </div>:''
                                         }
                                         {this.state.headCountMRCCode != ''?
                                         <div>
                                        <div className="selectedSummaryHeader"><b>Headcount MRC</b></div>
                                        {this.state.headCountMRCCode} - {this.state.headCountMRCName}<br/><br/>
                                         </div>:''
                                         }
                                         {this.state.headcountCCCode != ''?
                                         <div>
                                        <div className="selectedSummaryHeader"><b>Headcount Cost Center</b></div>
                                        {this.state.headcountCCCode} - {this.state.headcountCCName}<br/><br/><br/>
                                         </div>:''
                                         }
                                         </div>
                                    </div>
                                </div>
                                <div className="nextbtn lenext emailSubmitbtnWrapper">
                                    <input type="button" value="Send" className="btncls emailSubmitbtn" onClick={this.handleEmailSuccess} id="emailSubmitbtn"/>
                                </div>
                            </div>
                            
                        </div>
                        </Modal>
                        <Modal isOpen={this.state.emailSentSuccess}
                        className="Modal emailPopUpWrapper" ariaHideApp={false}>
                            <div className="outer emailErrorPopupOuterWrapper">
                                <div className="emailSuccessPopupWrapper">
                                    <div className="emailSuccessPopupContent">
                                    Your email has been sent successfully!
                                    </div>
                                    <div className="nextbtn lenext emailSubmitbtnWrapper">
                                        <input type="button" value="Ok" className="btncls emailSubmitbtn" onClick={this.handleEmailPopUp}/>
                                    </div>
                            </div>   
                            </div>
                        </Modal>
                        <Modal isOpen={this.state.emailSentError}
                        className="Modal emailPopUpWrapper" ariaHideApp={false}>
                            <div className="outer emailErrorPopupOuterWrapper">
                                <div className="emailErrorPopupWrapper">
                                    <div className="emailSuccessPopupContent">
                                    <h4>Error!</h4>
                                    Please verify the email address.
                                    </div>
                                    <div className="nextbtn lenext emailSubmitbtnWrapper">
                                        <input type="button" value="Ok" className="btncls emailSubmitbtn" onClick={this.handleErrorEmailPopUp}/>
                                    </div>
                            </div>   
                            </div>
                        </Modal>
                    {this.state.issurveyFeedback == 'false' ?
                        <div className='surveyDiv'>
                            <div className="surveyHeader">
                                <img className="surveyIcon" src={JNJSurvey} alt="Smiley face"></img>
                            </div>
                            <div className="surveyheadercontent">
                                <h4 className='surveylebelheader'>How did we do?</h4>
                                <p className="surveycontent"><span> <a href={this.state.surveyURL} target="_blank" onClick={this.surveyPage} className="surveyLink">Answer 3 quick questions</a></span> to let us know what you think of this tool. Thanks!</p>
                            </div>

                        </div> : ''}
                </div>
            }
            </div>
        );
    }
}

export default withCookies(EndPage);